import { func } from 'prop-types';
import { themes } from '../styles/themes';

export function getElecNomAmbitoName(currentNomenclator, nomAmbitoName) {
  const currentNomAmbitos = currentNomenclator?.nomAmbitos;
  const keyValueArray = Object.entries(currentNomAmbitos);
  let result;

  for (let index = 0; index < keyValueArray.length; index++) {
    const element = keyValueArray[index];
    if (element[1].n.toLowerCase() === nomAmbitoName) {
      result = element[0];
    }
  }

  return result;
}

export function getNomenclatorColorsByElecCode(currentNomenclator, elec) {
  const currentNomenclatorElec = currentNomenclator?.nomAmbitos[elec];
  const nomenclatorColor = currentNomenclatorElec?.c ?? themes['default'].c;
  const nomenclatorColorSecondary =
    currentNomenclatorElec?.cs ?? themes['default'].cs;
  return { c: nomenclatorColor, cs: nomenclatorColorSecondary };
}

export function getNomenclatorColorsByElecName(
  currentNomenclator,
  nomAmbitoName
) {
  return getNomenclatorColorsByElecCode(
    currentNomenclator,
    getElecNomAmbitoName(currentNomenclator, nomAmbitoName)
  );
}

export function getAmbitoByCode(currentNomenclator, elec, codigo) {
  const currentNomAmbitos = currentNomenclator?.ambitos[elec];
  if (!currentNomAmbitos) {
    return currentNomenclator?.ambitos["10"][0];
  }
  const ambito = currentNomAmbitos.find(ambito => ambito.c === codigo);
  return ambito;
}
